module.exports = require("npm:process@0.11.2/browser.js");